import ApiCaller from './ApiCaller';
import baseAjaxConfig from './BaseAjaxConfig';

export const SELLERS_PAGE_REQUEST = 'SELLERS_PAGE_REQUEST';
export const SELLERS_PAGE_SUCCESS = 'SELLERS_PAGE_SUCCESS';
export const SELLERS_PAGE_ERROR = 'SELLERS_PAGE_ERROR';

export function sellersPageRequestAction() {
	return { type: SELLERS_PAGE_REQUEST };
}

export function sellersPageSuccessAction(data) {
	return { type: SELLERS_PAGE_SUCCESS, data };
}

export function sellersPageErrorAction(error) {
	return { type: SELLERS_PAGE_ERROR, error };
}

export function fetchSellersPageData(pid, pincode = null) {
	let requestBody = {
		requestContext: {
			productId: pid
		}
	};
	return (dispatch, getState) => {
		dispatch(sellersPageRequestAction());
		const appState = getState();
		requestBody = Object.assign({}, requestBody, {
			locationContext: { pincode: appState.userState.pincode }
		});
		return ApiCaller.post(
			Object.assign({}, baseAjaxConfig, {
				pathname: '/api/3/page/dynamic/product-sellers'
			}),
			requestBody
		).then(
			data => dispatch(sellersPageSuccessAction(data['RESPONSE'])),
			err => {
				dispatch(sellersPageErrorAction(err));
				return Promise.reject(err);
			}
		);
	};
}
